import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

interface InstanceStatusState {
  id: idArr[];
  loading: boolean;
  completedDetails: Record<string, any>;
  lastCompleted: any | null;
}

interface idArr {
  instance_id: string;
  message: string;
  status: string;
}

const initialState: InstanceStatusState = {
  id: [],
  loading: false,
  completedDetails: {},
  lastCompleted: null,
};

export const instanceStatusSlice = createSlice({
  name: "instanceLoadingStatus",
  initialState,
  reducers: {
    updateInstanceLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    updateActiveInstances: (state, action) => {
      const { instance_id, message, status } = action.payload;
      const index = state.id.findIndex(
        (item: any) => String(item.instance_id) === String(instance_id)
      );

      if (index !== -1) {
        // update existing entry
        state.id[index].message = message;
        state.id[index].status = status;
      } else {
        // add new entry
        state.id.push({ instance_id, message, status });
      }
    },
    setInstanceCompleted: (
      state,
      action: PayloadAction<{ instance_id: string | number; detail: any }>
    ) => {
      const { instance_id, detail } = action.payload;
      state.id = state.id.filter(
        (item) => String(item.instance_id) !== String(instance_id)
      );
      if (detail) {
        state.completedDetails[String(instance_id)] = detail;
        state.lastCompleted = detail;
      }
    },
    removeSingleInstance: (state, action: PayloadAction<any>) => {
      state.id = state.id.filter(
        (item) => String(item.instance_id) !== String(action.payload)
      );
    },
    removeAllInstance: (state) => {
      return initialState;
    },
  },
});

export const {
  updateActiveInstances,
  updateInstanceLoading,
  setInstanceCompleted,
  removeSingleInstance,
  removeAllInstance,
} = instanceStatusSlice.actions;

export default instanceStatusSlice.reducer;
